import React from 'react'
import { AboutContainer,AboutWrapper, AboutContent, AboutHeading, Aboutp } from './AboutElement'

const Aboutt = () => {
    return (
        <AboutContainer>
            <AboutWrapper>
                <AboutContent data-aos="fade-left">
                    <AboutHeading>WHY CHOOSE <span style={{color:"#05386B"}}> US </span>.</AboutHeading>
                    <Aboutp>Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                             At numquam tempora laboriosam doloremque minima aspernatur. 
                             Quas rerum quis repellendus perspiciatis quisquam excepturi 
                             minima adipisci eveniet impedit corporis aut, sed ex maiores!
                              Fuga ad quasi pariatur possimus sequi unde similique ducimus.
                    </Aboutp>
                </AboutContent>
                <AboutContent data-aos="fade-right">
                <AboutHeading>OUR <span style={{color:"#05386B"}}> MISSION </span>.</AboutHeading>
                    <Aboutp>Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                             At numquam tempora laboriosam doloremque minima aspernatur. 
                             Quas rerum quis repellendus perspiciatis quisquam excepturi 
                             minima adipisci eveniet impedit corporis aut, sed ex maiores!
                              Fuga ad quasi pariatur possimus sequi unde similique ducimus.
                    </Aboutp>
                </AboutContent>

                <AboutContent data-aos="fade-left">
                <AboutHeading>WHAT WE <span style={{color:"#05386B"}}> DO </span>.</AboutHeading>
                    <Aboutp>Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                             At numquam tempora laboriosam doloremque minima aspernatur. 
                             Quas rerum quis repellendus perspiciatis quisquam excepturi 
                             minima adipisci eveniet impedit corporis aut, sed ex maiores!
                              Fuga ad quasi pariatur possimus sequi unde similique ducimus.
                    </Aboutp>
                </AboutContent>
            </AboutWrapper>
        </AboutContainer>
    )
}

export default Aboutt
